var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedWarningWithBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14367_792)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    fill: "#FF5362",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3255 24.6011C43.2695 24.3771 43.1536 24.1722 42.9907 24.0093L35.9907 17.0093C35.8278 16.8464 35.6229 16.7305 35.3989 16.6745C35.2895 16.6465 32.6702 16 30 16C27.3298 16 24.7105 16.6465 24.5998 16.6745C24.3758 16.7305 24.1722 16.8464 24.0093 17.0093L17.0093 24.0093C16.8464 24.1722 16.7305 24.3771 16.6745 24.6011C16.6478 24.7105 16 27.3298 16 30C16 32.6702 16.6465 35.2895 16.6745 35.3989C16.7305 35.6229 16.8464 35.8278 17.0093 35.9907L24.0093 42.9907C24.1722 43.1536 24.3771 43.2695 24.5998 43.3255C24.7105 43.3535 27.3285 44 30 44C32.6715 44 35.2895 43.3535 35.3989 43.3255C35.6229 43.2695 35.8278 43.1536 35.9907 42.9907L42.9907 35.9907C43.1536 35.8278 43.2695 35.6229 43.3255 35.3989C43.3535 35.2895 44 32.6702 44 30C44 27.3298 43.3535 24.7105 43.3255 24.6011ZM40.9315 34.4495L34.4495 40.9327C33.7087 41.0931 31.8429 41.4545 30 41.4545C28.1571 41.4545 26.2925 41.0931 25.5493 40.9315L19.0673 34.4495C18.9069 33.7087 19.0673 38.2065 19.0673 36.3636C19.0673 34.5207 23.3384 40.7251 23.5 39.9831L30 43.3255L37 41.4545C37.7407 41.2942 38.1558 37.6364 40 37.6364C41.8442 37.6364 42.2487 34.2878 42.9907 34.4495L40.9327 25.5505C41.0931 26.2913 41.4545 28.1571 41.4545 30C41.4545 31.8429 41.0931 33.7075 40.9315 34.4495ZM28.7273 31.2727V23.6364C28.7273 22.9325 29.2975 22.3636 30 22.3636C30.7025 22.3636 31.2727 22.9325 31.2727 23.6364V31.2727C31.2727 31.9765 30.7025 32.5455 30 32.5455C29.2975 32.5455 28.7273 31.9765 28.7273 31.2727ZM31.2727 36.3636C31.2727 37.0662 30.7025 37.6364 30 37.6364C29.2975 37.6364 28.7273 37.0662 28.7273 36.3636C28.7273 35.6611 29.2975 35.0909 30 35.0909C30.7025 35.0909 31.2727 35.6611 31.2727 36.3636Z",
    fill: "#FF5362"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14367_792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedWarningWithBg);
export default __webpack_public_path__ + "static/media/red-warning-with-bg.f98fd57ebb11e0cb4ca5ead1abeae00d.svg";
export { ForwardRef as ReactComponent };